import {reportStartCheckout} from "../utility/startCheckout";
import {getClassList} from "../../../Utility/siteConfig";
import React from "react";
import CheckoutPath from "../../services/CheckoutPath";

export default function PrimaryCheckoutButton({shoppingCart, cartCode, checkoutPath}) {
  checkoutPath || (checkoutPath = getCheckoutPath(cartCode, shoppingCart));

  const handleClick = (evt) => {
    reportStartCheckout({
      shoppingCart, checkoutType: 'credit_card'
    });
  };

  // const common = getClassList({
  //   key: 'CheckoutButton.common',
  //   fallback: CHECKOUT_BUTTON_CLASSES
  // })

  const className = getClassList({
    key: "CheckoutButton.main",
    fallback:
      'btn-primary !text-anti-primary',
    base: [ // block is required because it's an A tag!
      'block w-full py-3 mt-4',
      'uppercase text-xl'
    ]
  })

  // FIXME CARLYLE THEME
  const styles = {
    // boxShadow: '0px 1px 0px darkgreen',
    // borderBottom: '2px solid darkgreen'
  };

  return <a
    style={styles}
    className={className}
    href={checkoutPath} onClick={handleClick}>
    <span className="fa fa-lock mr-2"/>
    {" "}
    Secure Checkout
  </a>
}

function getCheckoutPath(cartCode, shoppingCart) {
  let cp = new CheckoutPath({
    cartCode, cart: shoppingCart
  })
  return cp.toString()
}
